<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<!-- <el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"			
			:row-class-name="tableRowClassName"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="relation_requisition_no" :label="$t('getapi[1480]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[1596]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="row_number" :label="$t('getapi[1425]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="commodity_type_name" :label="$t('getapi[120]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_status" :label="$t('getapi[552]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="on_qty" :label="$t('getapi[1620]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_net_unitprice" :label="$t('getapi[3711]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_total_unitprice" :label="$t('getapi[3958]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_net_amount" :label="$t('getapi[3712]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3959]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="actual_time" :label="$t('getapi[1612]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_net_amount_base" :label="$t('getapi[1609]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_total_amount_base" :label="$t('getapi[1610]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_tax_amount" :label="$t('getapi[1611]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="po_qty" :label="$t('getapi[1557]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="plan_date" :label="$t('getapi[1613]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="origin_plan_date" :label="$t('getapi[1601]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="prdate" :label="$t('getapi[1614]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="first_vender_flag" :label="$t('getapi[1615]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="pur_measureunit" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[1602]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[576]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="specification" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="stuff_manuf_name" :label="$t('getapi[192]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1617]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="actual_qty" :label="$t('getapi[1618]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="un_qty_order" :label="$t('getapi[1619]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[4279]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="check_flag" :label="$t('getapi[1308]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="plan_person" :label="$t('getapi[163]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="consumption_date" :label="$t('getapi[1512]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="products" :label="$t('getapi[145]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="key_flag" :label="$t('getapi[146]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mro_order_no" :label="$t('getapi[6105]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="application_department" :label="$t('getapi[6041]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="application_person" :label="$t('getapi[3856]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="fa_flag" :label="$t('getapi[6106]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[158]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="routing_sequence" :label="$t('getapi[2326]')"></el-table-column>
			<el-table-column show-overflow-tooltip fixed="right" :label="$t('basic.edit')" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="lct(scope)" type="text" size="mini">采购业务图</el-button>
				</template>
			</el-table-column>
		</el-table> -->
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<!--<wTable id="xpane-0" :data="dataSet" :loading="loading" queryData="PurOrderLineViewInfo" :header="tableHeader" :option="tableOption"  @lct="lct"></wTable>-->
				<div id="xpane-0">
					<vTable
							:data="dataSet"
							:loading="loading"
							queryData="PurOrderLineViewInfo"
							:filter_language="['line_status','check_flag','first_vender_flag','key_flag','fa_flag']"
							:filter_thousandth="['on_qty','po_qty','actual_qty','receive_qty','un_qty_order',
							'purchase_leadtime']"
							:filter_thousandth_purprice="['line_net_unitprice','line_total_unitprice']"
							:filter_thousandth_puramount="['line_net_amount','line_total_amount','line_net_amount_base','line_total_amount_base','line_tax_amount']"
							:filter_date="['plan_date','actual_time','prdate']"
							:height="tableHeight"
							:header="tableHeader"
							:option="tableOption"
							@lct="lct"
							:checkflg="false"
							ref="singleTable"></vTable>
				</div>
			</li>
		</ul>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurOrderLineViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[104]')" queryData="PurOrderLineViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purorderdetailview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('purorderdetailview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			authority_showprice: false,
			tableHeader: [],
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
        that.$nextTick(function () {
            that.$processdata.initForm()
        })
		console.log('分页数' + that.pageSize)
		that.authority();		
		that.colsort();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[104]"),this.$t("getapi[16]"));
        },
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('PurOrderLineViewInfo',0,PFileds=>{
				that.tableHeader=PFileds;		
			});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
            if(that.$limits.authority('plv4', 59, 1) ==  0){
                that.authority_showprice = false
            } else {
                that.authority_showprice = true
            }
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 66, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 66, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('purorderdetailview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurOrderLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		//表格背景
		tableRowClassName({row, rowIndex }) {
			row.index = rowIndex;
			if (!this.$limits.fnIsEmpty(row.fa_flag)) {
				if (row.fa_flag == '是' && row.line_status !='关闭') {
					if (row.po_qty - row.receive_qty > 0){
						return 'orange';
					}
				}
			}
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pur/Order/PurOrderDataListDetail', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
                    that.$nextTick(function () {
                        that.$processdata.initForm(0)
                    })
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Pur/Order/PurOrderExportToExeclDetail', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "PurOrderLineViewInfo",
                fromname: that.$t('getapi[104]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		//销售关系
		lct(row) {
            let that = this
            that.$store.commit('setSharedParams',row.row);
			let item = {
				label: '采购业务图',
				name: 'purbusiness',
				path: '/purbusiness/order',
				url: '/purbusiness/order',
				icon: 'video-play'
			};
			this.$router.push({ path: '/purbusiness/order'});
			this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		}
	}
};
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
    /deep/ .orange {
        background:  #FF8C00;
    }
</style>

